import { useMemo, useState } from 'react';
import { AxiosRequestConfig } from 'axios';
import { getCoreRowModel } from '@tanstack/react-table';

import { makeChangeLogColumns } from '../../utils/columns/makeChangeLogColumns';

import { ChangeLog } from '../../types/ChangeLog';
import { SingleResult } from '../../types/SingleResult';
import { PaginatedResult } from '../../types/PaginatedResult';

import { Table, useStandardTable as useTable } from './table';

interface ChangeLogProps {
  fetchAsync: (params: any, config?: AxiosRequestConfig) => Promise<SingleResult<PaginatedResult<ChangeLog>> | null>;
}

export default function ChangeLogList(props: ChangeLogProps) {
  const [paramFilter] = useState<any>({
    sortBy: [
      {
        createdDateTime: '-1',
      },
    ],
  });
  const columns = useMemo(() => makeChangeLogColumns(), []);
  const table = useTable<any>({
    columns,
    accessKey: 'changelog',
    fetchAsync: props.fetchAsync,
    //   exportAsync: exportFacilities,
    params: paramFilter,
    serverSide: true,
  });

  return <Table {...table} showSearchBar={false} showColumnToggler={false} showAction={true} getCoreRowModel={getCoreRowModel()} />;
}
